module.exports = __webpack_public_path__ + "img/w3_pdf_white.42525190.png";